var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1296_11628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2459 4.5H0V2.5H14.2459V4.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 3.5C13.25 1.567 14.817 0 16.75 0C18.683 0 20.25 1.567 20.25 3.5C20.25 5.433 18.683 7 16.75 7C14.817 7 13.25 5.433 13.25 3.5ZM16.75 2C15.9216 2 15.25 2.67158 15.25 3.5C15.25 4.32842 15.9216 5 16.75 5C17.5784 5 18.25 4.32842 18.25 3.5C18.25 2.67158 17.5784 2 16.75 2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 4.5H19.2485V2.5H24.0002V4.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2515 21.5H0V19.5H14.2515V21.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 20.5C13.25 18.567 14.817 17 16.75 17C18.683 17 20.25 18.567 20.25 20.5C20.25 22.433 18.683 24 16.75 24C14.817 24 13.25 22.433 13.25 20.5ZM16.75 19C15.9216 19 15.25 19.6716 15.25 20.5C15.25 21.3284 15.9216 22 16.75 22C17.5784 22 18.25 21.3284 18.25 20.5C18.25 19.6716 17.5784 19 16.75 19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9998 21.5H19.2529V19.5H23.9998V21.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11H24V13H11V11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 10.067 6.567 8.5 8.5 8.5C10.433 8.5 12 10.067 12 12C12 13.933 10.433 15.5 8.5 15.5C6.567 15.5 5 13.933 5 12ZM8.5 10.5C7.67158 10.5 7 11.1716 7 12C7 12.8284 7.67158 13.5 8.5 13.5C9.32842 13.5 10 12.8284 10 12C10 11.1716 9.32842 10.5 8.5 10.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11H6V13H0V11Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1296_11628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.d5597beda31e0610d17dcf2c95b0ac3a.svg";
export { ForwardRef as ReactComponent };